import { Button, ButtonsGroup, Flex, Typo } from "#/atoms";
import { DESKTOP_SPACING, FONT_WEIGHT } from "@/theme";
import { FC, memo } from "react";

import { MissingOrderInfoProps } from "./MissingOrderInfo.interface";
import { Modal } from "#/molecules";


const MissingOrderInfo: FC<MissingOrderInfoProps> = ({ floorAreaMissing, virtualTourPhotosMissing, onClose, onConfirm }) => {
  
    return (
    <Modal onClose={onClose} title="Missing Information" width="600px">
      <Flex alignContent="center" alignItems="center" flexDirection="column" justifyContent="center" >
        <Typo>The following information is missing</Typo>
        <br/>
        { floorAreaMissing && <Typo margin="5px 0px" weight={FONT_WEIGHT.BOLD}>The floor area information</Typo> }
        { virtualTourPhotosMissing && <Typo margin="5px 0px" weight={FONT_WEIGHT.BOLD}>The total number of 360 images</Typo> }
        <br/>
        <Typo>Are you sure you want to save?</Typo>
      </Flex>
      <ButtonsGroup fullWidth margin={`${DESKTOP_SPACING.EL}px 0 0`}>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm}>Confirm</Button>
      </ButtonsGroup>
    </Modal>
  );
}

export default memo(MissingOrderInfo);